import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { useSelector } from 'react-redux';
import store from '../../../store';

if (typeof window !== 'undefined') {
  require('swiper/css');
  require('swiper/css/navigation');
}

// Custom Previous Arrow
const PrevArrow = ({ onClick }) => (
  <button className="arrow prev" onClick={onClick}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-chevron-left"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
      />
    </svg>
  </button>
);

// Custom Next Arrow
const NextArrow = ({ onClick }) => (
  <button className="arrow next" onClick={onClick}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-chevron-right"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
      />
    </svg>
  </button>
);

export default function HomeSlider() {
  const [slides, setSlides] = useState([]);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const currentUser = useSelector(state => state.user.currentUser);
  const userType = isAuthenticated
    ? currentUser?.attributes?.profile?.publicData?.userType
    : '';
  const postArtworkLink = isAuthenticated
    ? userType === 'seller'
      ? '/l/draft/00000000-0000-0000-0000-000000000000/new/details'
      : '/p/request_to_sell'
    : '/login';
  console.log(userType);

  useEffect(() => {
    fetch('https://cfmart-backend.onrender.com/api/listings')
      .then(res => res.json())
      .then(data => {
        setSlides(data);
      })
      .catch(err => console.error('API error:', err));
    // const state = store.getState();
    console.log('isAuthenticated', store);
  }, []);

  return (
    <>
      <div className="homepage-carousel">
        <h2>A FRIENDLY PLACE TO BUY & SELL ORIGINAL WORKS OF ART</h2>
        <a class="cta-light" href="/s">
          Browse All
        </a>

        <div className="slider-wrapper">
          <Swiper
            spaceBetween={50}
            slidesPerView={1}
            className="homepage-slider-wrapper"
            modules={[Navigation]}
            navigation={{
              nextEl: '.slider-arrows .next',
              prevEl: '.slider-arrows .prev',
            }}
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {slides.map((slide, idx) => (
              <SwiperSlide key={idx}>
                <Link to={slide.permalink} key={idx}>
                  <img src={slide.image} alt={slide.author} />
                  <p>{slide.author}</p>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="slider-arrows">
            <PrevArrow />
            <NextArrow />
          </div>
        </div>

        <h3>
          WE ENCOURAGE EVERYONE TO POST WORK—<br></br>YOU NEVER KNOW WHO WILL
          FIND IT, LOVE IT AND NEED IT!
        </h3>
        <Link
          class="cta-light mb-0"
          to={'/l/draft/00000000-0000-0000-0000-000000000000/new/details'}
        >
          Post Artwork
        </Link>
      </div>
    </>
  );
}
